import debounce from './debounce';
import deepClone from './deep-clone';
import formatDate from './format-date';
import kebabCase from './kebab-case';
import isObject from './is-object';

export default {
    debounce,
    deepClone,
    formatDate,
    kebabCase,
    isObject,
};
